import { useSiteContentState } from './useSiteContent'
import fallbackCatalog from '../api/fallback/catalog.json'

// Même patron que les informations pratiques : la copie embarquée à la
// compilation s'affiche d'abord, l'API la remplace dès qu'elle répond. Si elle
// ne répond pas, le visiteur voit un catalogue éventuellement daté plutôt
// qu'une page de tarifs vide.
export function useCatalog() {
  const { data, status } = useSiteContentState('catalog', fallbackCatalog)
  return { catalog: data, status }
}
